// Port of https://github.schibsted.io/finn/mfinn/blob/master/src/main/webapp/modules/controllers/adPaging.js

const storageKey = 'searchItems';
const isBrowser = typeof document !== 'undefined';

export const loadFromStorage = () => {
    try {
        const stringData = isBrowser && window.sessionStorage.getItem(storageKey);
        let data = null;
        if (stringData) {
            data = JSON.parse(stringData);
        }
        return data && data.urls && data.search ? data : null;
    } catch (e) {
        return null;
    } // ignore session storage missing or incognito mode
};

const digitRegex = /(\d)+/;
const getAdIdFromUrl = url => {
    // Attempt to find finnkode from i.e.
    // /realestate/homes/ad.html?finnkode=262926776 or /realestate/homes/262926776
    // or /realestate/leisuresale/ad.html?finnkode=242363570
    const match = url.match(digitRegex);
    if (match && match.length > 0) {
        return match[0];
    }
    return null;
};

const getListWithUniqueValues = adUrlList => {
    const res = adUrlList.reduce(
        ({ acc, uniqueChecker }, currentAdUrl) => {
            const adId = getAdIdFromUrl(currentAdUrl);
            if (adId && uniqueChecker.has(adId)) {
                return { uniqueChecker, acc };
            }
            return { uniqueChecker: uniqueChecker.add(adId || ''), acc: [...acc, currentAdUrl] };
        },
        { uniqueChecker: new Set(), acc: [] }
    );
    return res.acc;
};

const findAdIds = data => {
    const urls = data.urls.filter(u => u !== null);
    return getListWithUniqueValues(urls);
};

const getThisIndex = (adUrls, currentAdId) => adUrls.findIndex(adUrl => adUrl.includes(currentAdId));

const pagingLinks = (adUrls, currentAdId) => {
    const thisIndex = getThisIndex(adUrls, currentAdId);
    return thisIndex === -1 ? [] : [adUrls[thisIndex - 1], adUrls[thisIndex + 1]];
};

export const handlePagingKeyDown = nextPage => event => {
    if (event.target.closest('input, textarea')) {
        return;
    }

    if (event.code === 'ArrowRight' && (event.metaKey || event.altKey) && !event.shiftKey && !event.ctrlKey) {
        // Normally, Alt/Cmd-RightArrow navigates forward. If there's
        // no forward history, navigate to the next item.
        // Wait 100 ms and assume navigation has happened.
        window.setTimeout(() => {
            // TODO tracking?
            window.location.href = nextPage;
        }, 100);
    }
};

export const getPagingData = (currentAdId, loader) => {
    const pagingData = loader();
    const adUrls = pagingData ? findAdIds(pagingData) : [];
    if (pagingData && adUrls.find(adUrl => adUrl.includes(currentAdId))) {
        const [prev, next] = pagingLinks(adUrls, currentAdId);
        return { prev, next, search: pagingData.search };
    }
    return null;
};
